import React, { useState } from 'react';
import PercentageCircle from "./../components/PercentageCircle";
import Progress from "./../components/Progress"
import classNames from 'classnames';
import useMedia from '../../Hooks/useMedia'
import CompareCareLabelTooltip from './labelTooltip';
import MatomoTrackRequest from './../../Matomo/matomo-track-request';

const UnitValueMeasureKey = '0';
const CountyValueMeasureKey = '1';
const CountryValueMeasureKey = '2';

const Indicator = ({ indicator }) => {

    const isSmallViewport = useSmallViewport();

    const getMeasureValue = (measureValues, key) => {
        return measureValues?.find(mv => mv.Key === key);
    };

    const getIndicatorText = (text, key) => { 
        if (key === CountyValueMeasureKey)
            return "Genomsnitt för Region";
        if (key === CountryValueMeasureKey)
            return "Genomsnitt för Sverige";
        return text;
    }

    const getIndicator = (measureValue) => measureValue ? ({
        value: measureValue.Value * 100,
        text: getIndicatorText(measureValue.Text, measureValue.Key),
        size: measureValue.Key === CountyValueMeasureKey ? 20 : 26,
        legendSize: 15
    }) : undefined;

    const getPercentageValue = (value) => { 
        return value ? Math.min(Math.round(value * 100), 100) : 0;
    }

    const onOpenIndicator = () => { 
        MatomoTrackRequest("Indikator", "open_indicator", indicator.Header, "");
    }

    const unitMeasureValue = getMeasureValue(indicator.MeasureValues, UnitValueMeasureKey);
    const unitPercentageValue = getPercentageValue(unitMeasureValue?.Value);

    const countyMeasureValue = getMeasureValue(indicator.MeasureValues, CountyValueMeasureKey);
    const countryMeasureValue = getMeasureValue(indicator.MeasureValues, CountryValueMeasureKey);

    return <IndicatorAccordion header={indicator.Header} onOpen={onOpenIndicator}>
        <div className="quality-indicators__container">
            <div className="quality-indicators__container__info">
                <p className="quality-indicators__container__info--description">{indicator.Description}</p>
                <TextValues items={indicator.DescriptionValues} />
                <ul className="quality-indicators__container__info--values">
                    {indicator.MeasureValues.map(mv => <li key={ mv.Key }>{mv.Text}: <b>{getPercentageValue(mv.Value)}%</b></li>)}
                </ul>
                <Information indicator={ indicator } />
            </div>
            {!isSmallViewport && <PercentageCircle value={unitPercentageValue} size={200} strokeWidth={10} whiteIndicator={getIndicator(countyMeasureValue)} blackIndicator={getIndicator(countryMeasureValue)} />}
            {isSmallViewport && indicator.MeasureValues.map(mv => <Progress key={ mv.Text } percent={getPercentageValue(mv.Value)} text={ mv.Text } />)}
        </div>
        <div className="quality-indicators__container__footer">
            <TextValues items={indicator.Footers} />
        </div>
    </IndicatorAccordion>
};

const Information = ({ indicator }) => {
    const isSmallViewport = useSmallViewport();

    if (indicator.Information && indicator.InformationHeader) {
        if (isSmallViewport) {
            return <div className='quality-indicators__container__info--informationTooltip'>
                <CompareCareLabelTooltip tooltipContent={indicator.Information}>
                    <p>{indicator.InformationHeader}</p>
                </CompareCareLabelTooltip>
            </div>;
        } else {
            return <>
                <p className='quality-indicators__container__info--informationHeader'>{indicator.InformationHeader}</p>
                <p className='quality-indicators__container__info--information'>{indicator.Information}</p>
            </>;
        }
    }  
    return <></>;
};

const IndicatorAccordion = ({ header, children, onOpen }) => {

    const [open, setOpen] = useState(false);

    const classes = classNames({
        "quality-indicators__accordion__headline": true,
        "quality-indicators__accordion__headline--expanded": open
    });

    const onAccordionChange = () => { 
        setOpen(!open);
        if (onOpen && !open) { 
            onOpen();
        }
    }

    return <div className="quality-indicators__accordion quality-indicators__accordion--is-child">
        <button onClick={onAccordionChange} className="quality-indicators__accordion__button quality-indicators__accordion__button--s" aria-controls="accordion-id" aria-expanded="false">
            <div className={classes}>
                <h3>{header}</h3>
            </div>
        </button>
        {open && <div id="accordion-id" className="quality-indicators__accordion__content">{children}</div>}
    </div>
}

const TextValues = ({ items }) => {
    return items && items.length > 0 ? <div className="quality-indicators__textValue">
        {items.map(item => <div key={item.Text}><b>{item.Text}:</b> {item.Value}</div>)}
    </div> : <></>;
}

const useSmallViewport = () => useMedia(['(max-width: 640px)'], [true], false);


export default Indicator;